const defaults = {
  activeClass: `accordion--expanded`,
  toggleSelector: `.accordion__toggle`,
  contentSelector: `.accordion__content`,
};

export default class Accordion {
  constructor(element, options) {
    this.element = element;
    this.settings = { ...defaults, ...options };
    this.toggle = this.getToggle();
    this.content = this.getContent();

    if (this.toggle && this.content) {
      this.listen();
    }
  }

  clickHandler(event) {
    if (this.isExpanded) {
      this.collapse();
    } else {
      this.expand(event);
    }

    // Dispatch a change event for ease of use.
    this.element.dispatchEvent(new Event('ACCORDION_CHANGE'));
  }

  expand(event) {
    const { focus } = event.detail;
    this.toggle.setAttribute('aria-expanded', true);
    this.element.classList.add(this.settings.activeClass);
    this.content.removeAttribute('hidden');

    // Adds functionality to focus, but not scroll to the element.
    if (focus) {
      this.toggle.focus({ preventScroll: true });
    }
  }

  collapse() {
    this.toggle.setAttribute('aria-expanded', false);
    this.element.classList.remove(this.settings.activeClass);
    this.content.setAttribute('hidden', '');
  }

  listen() {
    this.toggle.addEventListener('click', this.clickHandler.bind(this));
  }

  getToggle() {
    return this.element.querySelector(this.settings.toggleSelector);
  }

  getContent() {
    return this.element.querySelector(this.settings.contentSelector);
  }

  get isExpanded() {
    return this.element.classList.contains(this.settings.activeClass);
  }
}
